import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderAdmin } from '../../../components/molecues';
import { Button, Select, Calendar, Toast, LoadingView } from '../../../../common/components/atoms';
import { ModalDialog } from '../../../../common/components/molecues';

import { validationDatetime, validationNumeric } from '../../../../common/helper/validation.js';

import { NOTICE_TARGET, ERROR_MESSAGE } from '../../../common/constants.js';
import { PopupMessage, POPUP_TYPE } from '../../../common/PopupMessage';

const EditRow = (props) => {
    return (
        <Row Display={props.Display}>
            <Title>
                {props.title}
            </Title>
            <Data style={props.dataStyle}>
                {props.data}
            </Data>
        </Row>
    )
}
class NoticeEdit extends Component {
    constructor(props) {
        super(props);

        this.refCalendar = React.createRef();
        this.refTable = React.createRef();
        this.refToast = React.createRef();
        this.state = {
            id:  this.props.noticeEdit ? this.props.noticeEdit.id : "",
            expireDate: this.props.noticeEdit ? this.props.noticeEdit.expireDate : this.getDisplayDate(),
            target: this.props.noticeEdit ? this.getTargetIndex(this.props.noticeEdit.target) : 0,
            targetID: this.props.noticeEdit ? this.props.noticeEdit.targetID : "",
            title: this.props.noticeEdit ? this.props.noticeEdit.title : "",
            contents: this.props.noticeEdit ? this.props.noticeEdit.contents : "",
            displayCalendar: false,

            displayDlg: false,
            calendarX: "0px",
            calendarY: "0px",
            calendarIconExpirationDate : false,
        }
    }
    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    getDisplayDate() {
        const today = new Date();
        let arr = today.toString().split(' ');
        let month = ( '00' + (today.getMonth() + 1) ).slice( -2 );
        let hours = ('00' + today.getHours()).slice(-2);
        let minutes = ('00' + today.getMinutes()).slice(-2);

        return arr[3] + '-' + month + '-' + arr[2] + ' ' + hours + ':' + minutes;
    }
    getTargetIndex(target) {
        for(let key in NOTICE_TARGET) {
            if(NOTICE_TARGET[key] === target) {
                return key;
            }
        }
        return 0;
    }

    onCilckUpdate = (e) => {
        let err = [];
        let syserr = [];
        if (this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if(this.state.expireDate !== "" && !validationDatetime(this.state.expireDate)) {
            err.push("有効期限が" + ERROR_MESSAGE["invalid_date"]);
        }
        if(this.state.target === "1" && this.state.targetID === "") {
            err.push("対象のユーザーID" + ERROR_MESSAGE["not_entered"]);
        }
        if(this.state.target === "1" && this.state.targetID !== "" && !validationNumeric(this.state.targetID)) {
            err.push("対象のユーザーIDには" + ERROR_MESSAGE["invalid_numeric"]);
        }
        if(this.state.title === "") {
            err.push("お知らせタイトル" + ERROR_MESSAGE["not_entered"]);
        }
        if(this.state.contents === "") {
            err.push("お知らせ内容" + ERROR_MESSAGE["not_entered"]);
        }
        if (err.length === 0 && syserr.length === 0) {
            this.setState({
                displayDlg: true,
            })
        } else {
            let message = [];
            for(let key in err) {
                message.push(
                    <div key={key}>
                        {err[key]}
                    </div>
                )
            }
            let errMessage;
            if (message.length > 0) {
                errMessage = PopupMessage({
                    type: POPUP_TYPE.INPUT_ERROR,
                    message: message
                });
            }
            message = [];
            for (let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            let syserrMessage;
            if (message.length > 0) {
                syserrMessage = PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message
                });
            }
            this.refToast.current.set(0, [
                syserrMessage,
                errMessage
            ]);
        }
    }
    onClickCancel = (e) => {
        this.props.history.push('/admin/notice');
    }

    onChange = (e) => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        });
    }

    onChageNoticeTarget = (e) => {
        this.setState({ target: e.target.value });
    }

    onClickCalendarIcon = (e) => {
        let rect = this.refCalendar.current.getCalendarRect();
        let y;
        let x = this.refTable.current.offsetLeft + this.refTable.current.clientWidth;
        if(rect.height + e.pageY > window.innerHeight) {
            y = window.innerHeight - rect.height - 32;
        } else {
            y = e.pageY;
        }
        this.setState({
            displayCalendar: true,
            calendarY: y + "px",
            calendarX: x + "px",
            calendarIconExpirationDate: true,
        });
    }
    onChangeDate = (date, target) => {
        let now = new Date();
        let hours = ('00' + now.getHours()).slice(-2);
        let minutes = ('00' + now.getMinutes()).slice(-2);
        let dateTime = date + " " + hours + ":" + minutes;
        this.setState({
            displayCalendar: false,
            expireDate: dateTime,
            calendarIconExpirationDate: false,
        });
    }
    onCalendarClose = (target) => {
        this.setState({
            displayCalendar: false,
            calendarIconExpirationDate: false,
        });
    }

    onSuccess = (list) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({
            displayDlg: false,
        })
        this.props.history.push('/admin/notice');
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({
            displayDlg: false,
        })
    }

    onClickSendCnf = () => {
        this.props.dispatch({
            type: "LoadStart"
        });
        let notice = {
            id: this.state.id,
            title: this.state.title,
            contents: this.state.contents,
            target: this.state.target,
            targetID: this.state.targetID,
            expireDate: this.state.expireDate,
            onSuccess: this.onSuccess,
            onFailure: this.onFailure,
        };
        this.props.dispatch({
            type: "SendNotice_Saga",
            ...notice
        });
    }
    onClickDlgCancel = () => {
        this.setState({
            displayDlg: false,
        })
    }

    createSendDlgProps() {
        return {
            display: this.state.displayDlg,
            contents: (
                <div style={{padding: "20px 0"}}>
                    この情報でお知らせを送信します。<br/>
                    よろしいですか？<br/>
                </div>
            ),
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickSendCnf,
                },
                'キャンセル': {
                    Color: '#000',
                    onClick: this.onClickDlgCancel,
                },
            },
            type: 1,
        }
    }

    render() {
        const width = window.innerWidth + "px";
        const height = (window.innerHeight-64-64) + "px";
        const propsHeader = {
            title: "お知らせ管理",
            history: this.props.history,
        }
        const propsCalendar = {
            display: this.state.displayCalendar,
            top: this.state.calendarY,
            left: this.state.calendarX,
            target: "",
            onClickDate: this.onChangeDate,
            onClose: this.onCalendarClose,
        }
        const propsToast = {
            timeout: 2000,
            bottom: "50px",
            right: "100px",
        };
        const propsSendDlg = this.createSendDlgProps();
        return (
            <Body>
                <HeaderAdmin {...propsHeader}></HeaderAdmin>
                <ContentsWrap Width={width} Height={height}>
                    <Contents>
                        <Table ref={this.refTable}>
                            <EditRow title="有効期限" 
                                data={[
                                    <input type="text" key="0" name="expireDate" value={this.state.expireDate}
                                        onChange={this.onChange} />,
                                    <Icon key="1" onClick={this.onClickCalendarIcon}
                                        Active={this.state.calendarIconExpirationDate}>
                                        <i className="far fa-calendar-alt" />
                                    </Icon>
                                ]} />
                            <EditRow title="送信対象" 
                                data={(
                                    <Select 
                                        array={NOTICE_TARGET} 
                                        onChange={this.onChageNoticeTarget} 
                                        value={this.state.target} 
                                        style={{
                                            padding: "2px 5px",
                                            color: "#888",
                                            width: "90%",
                                            border: "none",
                                            outline: "none",
                                        }}/>
                                )} />
                            <EditRow title="送信対象ID" 
                                data={(
                                    <input type="text" name="targetID" value={this.state.targetID}
                                            onChange={this.onChange} />
                                )} />
                            <EditRow title="お知らせタイトル" 
                                data={(
                                    <input type="text" name="title" value={this.state.title}
                                            onChange={this.onChange} />
                                )} />
                            <EditRow title="お知らせ内容" 
                                dataStyle={{borderBottom: "none"}}
                                data={(
                                    <textarea style={{width: "95%", height: "200px"}} name="contents" value={this.state.contents}
                                                onChange={this.onChange} />
                                )} />
                        </Table>
                    </Contents>
                </ContentsWrap>
                <Controls>
                    <Button 
                        Color="#0077FF" 
                        Width="100px"
                        onClick={this.onCilckUpdate}
                        icon={(<i className="fas fa-paper-plane" />)}
                        text="送信" />
                    <Button 
                        Color="#888888" 
                        Width="100px"
                        onClick={this.onClickCancel}
                        text="キャンセル" />
                </Controls>
                <Calendar ref={this.refCalendar} {...propsCalendar} />
                <Toast ref={this.refToast} {...propsToast} />
                <ModalDialog name="send-dialog" {...propsSendDlg} />
                <LoadingView Display={this.props.loading} />
            </Body>
        )
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading,
        permission: store.login.user.permission,
        noticeEdit: store.noticeEdit.notice,
    }
};

const connectedNoticeEdit = connect(mapStateToProps)(NoticeEdit);
export { connectedNoticeEdit as NoticeEdit };

const Body = styled.div`
`;
const ContentsWrap = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;;
    flex-direction: column;
    margin: auto;
    padding-top: 20px;
    width: 50%;
    width: ${props => props.Width};
    height: ${props => props.Height};
    overflow: hidden scroll;
`;
const Contents = styled.div`
`;

const Table = styled.div`
`;
const Row = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 5px 0;
`;
const Title = styled.div`
    background-color: #888;
    color: #fff;
    padding: 10px 20px;
    text-align: center;
    min-width: 100px;
    margin: 0 5px;
`;
const Data = styled.div`
    padding: 10px 20px;
    min-width: 300px;
    border-bottom: 1px solid #ddd;
    margin: 0 5px;
    color: #888;
    min-height: 16px;
    display: flex;
    align-items: center;

    input {
        border: none;
        border-radius: 0;
        width: 90%;
    }
`;

const Controls = styled.div`
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
`;
const Icon = styled.div`
    font-size: 16px;
    cursor: pointer;
    color: ${props => props.Active ? "#0077FF" : "#888888"};
`;